// frontend/src/components/ScrollContactButton.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ScrollContactButton = () => {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY || document.documentElement.scrollTop;
      setVisible(y > 160);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const goContact = () => navigate('/contact');

  return (
    <div
      aria-hidden={!visible}
      className={`fixed right-4 md:right-6 top-1/2 -translate-y-1/2 z-[98] transition-opacity duration-300 ${
        visible ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
      }`}
    >
      <button
        type="button"
        onClick={goContact}
        aria-label={t('nav.contact')}
        className="group relative flex flex-col items-center justify-center"
        style={{
          writingMode: 'vertical-rl',
          textOrientation: 'mixed'
        }}
      >
        {/* 黑色置中背景區塊 */}
        <span className="bg-black text-white font-semibold tracking-widest px-2 py-3 rounded-md shadow-lg shadow-black/40 hover:bg-neutral-900 transition-colors">
          {t('nav.contact')}
        </span>
        {/* 裝飾線 */}
        <span className="w-px h-8 bg-black/40 mt-2 group-hover:bg-black/70 transition-colors" />
      </button>
    </div>
  );
};

export default ScrollContactButton;